import React from "react";

import ManualEntryTable from "./ManualEntryTable";

import "./ManualEntryTableContainer.css";

const ManualEntryTableContainer = () => {
  return (
    <div className="manual-entries-table-container">
      <ManualEntryTable />
    </div>
  );
};

export default ManualEntryTableContainer;
